import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../controls/Modal';
import LabeledInput from '../../../controls/LabeledInput';
import LabeledSelect from '../../../controls/LabeledSelect';

// Модалка создания/редактирования площадки.
export default function VenueModal({ area, teams, smenaId, fairState, onClose }) {
    const editing = !!area;
    const [name, setName] = useState(area?.name || '');
    const [owner, setOwner] = useState(area?.teamStateId || '');

    const submit = async () => {
        if (!name.trim()) return;
        try {
            if (editing) {
                await fairState.updateTradingArea(area.id, { name: name.trim(), teamStateId: owner ? Number(owner) : null });
            } else {
                await fairState.createTradingArea(name.trim(), smenaId);
            }
            onClose();
        } catch (e) { /* ошибку покажет хук */ }
    };

    const ownerOptions = [{ key: '', value: '— не назначена —' }, ...teams.map(t => ({ key: t.id, value: t.teamName }))];

    return (
        <Modal
            open
            kicker="Площадка"
            title={editing ? 'Редактировать площадку' : 'Создать площадку'}
            size="sm"
            onClose={onClose}
            footer={(
                <>
                    <button type="button" className="btn btn-ghost" onClick={onClose}>Отмена</button>
                    <button type="button" className="btn btn-primary" onClick={submit} disabled={!name.trim()}>Сохранить</button>
                </>
            )}
        >
            {!editing && <div className="fr-sub">Команду-владельца можно назначить после создания</div>}
            <LabeledInput label="Название площадки" value={name} onChange={(e) => setName(e.target.value)} placeholder="Например, 1 корпус 1 этаж" />
            {editing && <LabeledSelect label="Команда-владелец" value={owner} onChange={(e) => setOwner(e.target.value)} options={ownerOptions} />}
        </Modal>
    );
}

VenueModal.propTypes = {
    area: PropTypes.object,
    teams: PropTypes.array.isRequired,
    smenaId: PropTypes.number,
    fairState: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
};

VenueModal.defaultProps = { area: null, smenaId: null };
